export default __webpack_public_path__ + "static/media/bigSprinter.15326062.jpg";